/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
// import { getSearchDataModeActive } from "@insite/client-framework/Store/Data/CatalogPages/Handlers";
import { chain, SetExpandTokens } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import {
    getSearchDataModeActive,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
replaceInChain(chain, SetExpandTokens, props => {
    props.expandTokens = ["attributes", "facets", "variantTraits", "badges"];
    if (getSearchDataModeActive(props.getState())) {
        props.expandTokens.push("scoreexplanation");
    }
});